import React from 'react';

/**
 * Custom SVG icons for organ systems with vibrant colors matching site palette
 * Uses SVG assets from src/assets/organ-*.svg with custom coloring
 */

const iconStyle = {
  width: '24px',
  height: '24px',
  display: 'block'
};

// Vibrant color palette matching website
const colors = {
  glucose: '#eab308',      // Yellow (blood sugar/pancreas)
  kidney: '#a855f7',       // Purple (kidneys)
  liver: {
    main: '#8B4513',       // Saddle brown - main lobe
    secondary: '#A0522D',  // Sienna - secondary lobe
    accent: '#6B3E26'      // Dark brown - accent
  },
  heart: '#ef4444',        // Site red (heart)
  blood: '#ef4444',        // Site red (RBC)
  shield: '#4ade80',       // Light green (immune)
  thyroid: '#6366f1',      // Indigo (thyroid)
  flame: '#f97316',        // Site orange (inflammation)
  stomach: '#14b8a6',      // Teal (digestion)
  bone: '#ddd0b8',         // Eggshell (bone)
  hormone: '#ec4899'       // Pink (hormones)
};

export function GlucoseIcon() {
  // Pancreas from organ-pancreas.svg - yellow colored
  return (
    <svg style={iconStyle} viewBox="0 0 260 168" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={colors.glucose} d="M258,32.421c0-8.549-6.929-15.478-15.478-15.478c-6.138,0-11.427,3.574-13.934,8.759c-2.678-2.221-6.109-3.545-9.855-3.545
        c-7.729,0-14.115,5.671-15.268,13.076c-2.84-2.116-6.338-3.383-10.15-3.383c-6.033,0-11.322,3.155-14.344,7.891
        c-2.897-1.897-6.357-3.012-10.083-3.012c-5.585,0-10.579,2.487-13.962,6.414c-3.383-3.803-8.292-6.214-13.781-6.214
        c-4.727,0-9.016,1.792-12.275,4.708c-3.45-3.412-8.177-5.518-13.4-5.518c-5.013,0-9.559,1.954-12.962,5.118
        c-3.736-3.307-8.644-5.318-14.029-5.318c-9.016,0-16.707,5.633-19.766,13.562c-1.63-0.41-3.345-0.619-5.099-0.619
        c-11.694,0-21.177,9.473-21.177,21.177c0,2.011,0.286,3.965,0.81,5.814c-2.912,1.492-5.428,3.644-7.364,6.25
        c-1.164-9.658-0.266-16.947,0.304-21.54c1.867-15.034,18.755-23.45,25.161-24.265l1.939-0.247l0.8-1.783
        c1.919-4.273,2.473-10.642,1.412-16.224c-1.082-5.689-3.984-10.847-8.171-14.526L55.98,2.334l-1.747,0.409
        C46.092,4.648,38.6,7.92,31.965,12.468C13.21,25.326,6.548,45.264,4.555,53.239c-6.733,26.941,0.104,59.664,17.418,83.368
        c11.922,16.32,30.816,26.536,53.195,28.765c1.93,0.195,3.889,0.294,5.821,0.294c25.917,0,38.945-17.922,47.565-29.78
        c2.927-4.027,7.824-10.792,9.597-10.521c2.492,0.353,3.576,1.221,4.434,2.412c4.337,6.045,3.477,20.346,2.419,25.941l-0.644,3.404
        l30.719,6.003l0.67-3.418c0.617-3.142,5.607-31.081-7.425-49.761c4.969-0.258,9.349-2.696,12.231-6.379
        c1.83,0.696,3.793,1.087,5.861,1.087c7.176,0,13.276-4.556,15.621-10.913c1.735,0.61,3.593,0.953,5.537,0.953
        c7.939,0,14.563-5.556,16.24-12.99c1.039,0.238,2.116,0.372,3.221,0.372c8.006,0,14.486-6.481,14.486-14.487
        c0-0.534-0.029-1.058-0.086-1.582c6.624-1.677,11.532-7.653,11.532-14.801c0-2.24-0.496-4.365-1.363-6.281
        C255.474,42.114,258,37.568,258,32.421z M92.597,63.605c3.688,0,6.671,2.983,6.671,6.671c0,3.688-2.983,6.671-6.671,6.671
        c-3.679,0-6.671-2.983-6.671-6.671C85.925,66.589,88.918,63.605,92.597,63.605z M82.414,96.092c4.511,0,8.18,3.669,8.18,8.179
        c0,4.511-3.669,8.181-8.18,8.181s-8.18-3.67-8.18-8.181C74.234,99.761,77.903,96.092,82.414,96.092z M68.999,82.381
        c3.946,0,7.148,3.193,7.148,7.148c0,0.083-0.01,0.164-0.013,0.247c-3.214,1.398-5.876,3.831-7.56,6.879
        c-3.755-0.221-6.723-3.324-6.723-7.126C61.851,85.574,65.044,82.381,68.999,82.381z M169.468,154.926l-17.109-3.343
        c0.863-7.408,1.109-20.593-4.116-27.874c-2.163-3.004-5.06-4.671-9.126-5.246c-5.654-0.784-9.445,4.028-16.203,13.325
        c-8.255,11.356-19.56,26.908-41.927,26.908c-1.7,0-3.422-0.087-5.125-0.259c-20.385-2.031-37.525-11.243-48.262-25.941
        C11.457,110.393,5.065,79.947,11.317,54.929c1.8-7.204,7.801-25.203,24.589-36.712c5.42-3.715,11.495-6.479,18.082-8.23
        c1.713,1.854,3.819,4.921,4.663,9.358c0.658,3.46,0.501,7.494-0.345,10.456C49.12,32.095,31.45,42.141,29.27,59.704
        c-0.868,6.995-2.435,19.793,2.598,37.497c0.748,6.336,4.29,11.815,9.368,15.173c-0.448,1.725-0.677,3.536-0.677,5.404
        c0,11.951,9.693,21.653,21.654,21.653c5.261,0,10.083-1.877,13.829-5.004c2.859,1.792,6.223,2.85,9.845,2.85
        c8.377,0,15.449-5.556,17.746-13.19c7.348-0.677,13.305-6.109,14.772-13.2c4.737-0.172,8.959-2.306,11.885-5.642
        c3.04,3.993,7.834,6.576,13.238,6.576c4.714,0,8.967-1.958,11.993-5.107c2.63,1.887,4.95,4.205,6.9,6.94
        C172.009,127.091,170.581,146.807,169.468,154.926z"/>
    </svg>
  );
}

export function KidneyIcon() {
  // Kidneys from organ-kidneys.svg - purple colored
  return (
    <svg style={iconStyle} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill={colors.kidney} d="M391.313,371.2c-34.56,0-59.793-19.473-67.49-52.096c-7.526-31.855,4.574-66.714,28.006-84.736
          c-10.172-6.801-20.855-19.106-20.855-42.368c0-23.757,9.677-36.659,18.944-43.904c-22.17-18.415-33.408-52.224-26.095-83.2
          c7.706-32.623,32.939-52.096,67.49-52.096C465.835,12.8,499.2,102.801,499.2,192S465.843,371.2,391.313,371.2z"/>
        <path fill={colors.kidney} d="M120.687,371.2C46.157,371.2,12.8,281.199,12.8,192S46.157,12.8,120.687,12.8
          c34.56,0,59.793,19.473,67.49,52.096c7.313,30.976-3.925,64.794-26.095,83.2c9.267,7.245,18.944,20.139,18.944,43.904
          c0,23.262-10.684,35.567-20.855,42.368c23.433,18.014,35.533,52.873,28.006,84.736C180.471,351.727,155.238,371.2,120.687,371.2z"/>
      </g>
      <g>
        <path fill="#7c3aed" opacity="0.7" d="M192.981,180.762c-1.783-14.251-6.673-24.883-12.698-32.555
          c19.209-22.212,27.716-55.04,20.352-86.246C191.607,23.74,160.981,0,120.687,0C37.316,0,0,96.435,0,192s37.316,192,120.687,192
          c40.294,0,70.929-23.74,79.949-61.961c7.518-31.829-1.485-65.34-21.504-87.552c6.716-7.578,10.965-16.759,13.082-27.298
          c3.635,1.408,6.135,3.217,7.74,4.838c20.028,20.198,19.302,89.353,18.253,194.048c-0.273,27.998-0.597,58.974-0.597,93.124
          c0,7.074,5.726,12.8,12.8,12.8s12.8-5.726,12.8-12.8c0-34.048,0.324-64.947,0.597-92.877
          c1.246-122.846,1.877-184.525-25.651-212.326C211.388,187.17,202.914,182.818,192.981,180.762z M168.226,192
          c0,47.539-53.837,32.512-23.774,47.539C192,263.313,192,358.4,120.687,358.4S25.6,263.313,25.6,192S49.374,25.6,120.687,25.6
          S192,120.687,144.461,144.461C123.196,155.085,168.226,144.461,168.226,192z"/>
        <path fill="#7c3aed" opacity="0.7" d="M391.313,0c-40.294,0-70.929,23.74-79.949,61.961c-7.364,31.206,1.143,64.034,20.352,86.246
          c-6.025,7.671-10.914,18.304-12.698,32.555c-9.933,2.057-18.406,6.409-25.165,13.235c-27.529,27.802-26.897,89.472-25.651,212.326
          c0.273,27.921,0.597,58.829,0.597,92.877c0,7.074,5.726,12.8,12.8,12.8s12.8-5.726,12.8-12.8c0-34.15-0.324-65.126-0.597-93.124
          c-1.05-104.704-1.775-173.85,18.253-194.048c1.604-1.63,4.105-3.43,7.74-4.838c2.116,10.539,6.366,19.721,13.082,27.298
          c-20.019,22.212-29.013,55.723-21.504,87.552c9.02,38.221,39.646,61.961,79.94,61.961C474.684,384,512,287.565,512,192
          S474.684,0,391.313,0z M391.313,358.4C320,358.4,320,263.313,367.539,239.539c30.071-15.036-23.774,0-23.774-47.539
          s45.03-36.915,23.774-47.539C320,120.687,320,25.6,391.313,25.6S486.4,120.687,486.4,192S462.626,358.4,391.313,358.4z"/>
      </g>
    </svg>
  );
}

export function LiverIcon() {
  // Liver from organ-liver.svg - liver-colored with different shades for each part
  return (
    <svg style={iconStyle} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Main right lobe - darkest */}
      <path fill={colors.liver.main} d="M154.13 98.45c-74.523-.454-118.57 44.693-124.821 87.952-13.777 104.53-24.78 197.596 42.572 226.59 21.234 9.14 139.689-96.135 223.23-119.239 10.255-63.758 9.712-95.298 3.509-157.142 0 0-3.245-18.8-17.582-21.94-29.596-6.482-80.816-16.355-126.909-16.22z"/>
      {/* Secondary lobe - medium brown */}
      <path fill={colors.liver.secondary} d="M422.065 108.763c-30.34-.091-65.864 3.56-95.367 9.5-6.687 1.347-10.656 15.303-9.916 19.024 5.8 59.214 6.503 87.53-2.395 149.486 165.98-69.253 180.409-116.413 178.531-136.756-2.967-32.153-33.145-41.14-70.853-41.254z"/>
      {/* Caudate lobe - lighter accent */}
      <path fill={colors.liver.accent} d="M284.659 314.628c-39.357 14.62-79.953 40.882-113.676 64.54 20.086 5.945 56.674 6.638 74.525-3.397 18.28-15.838 34.462-37.393 39.15-61.143z"/>
    </svg>
  );
}

export function HeartIcon() {
  // Simple solid heart shape
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill={colors.heart}
      />
    </svg>
  );
}

export function BloodIcon() {
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Blood drop */}
      <path
        d="M12 2c0 0-7 8-7 13 0 4 3.1 7 7 7s7-3 7-7c0-5-7-13-7-13z"
        fill={colors.blood}
      />
      {/* Red blood cell shape inside */}
      <ellipse cx="12" cy="15" rx="3" ry="1.8" fill={colors.blood} opacity="0.6"/>
      <ellipse cx="12" cy="15" rx="1.2" ry="0.6" fill="white" opacity="0.35"/>
      {/* Highlight */}
      <path
        d="M9 11c-.3 1-.3 2 0 3"
        stroke="white"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.35"
        fill="none"
      />
    </svg>
  );
}

export function ShieldIcon() {
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shield */}
      <path
        d="M12 2L4 5v6c0 5.5 3.4 10.3 8 12 4.6-1.7 8-6.5 8-12V5l-8-3z"
        fill={colors.shield}
      />
      {/* Plus/cross symbol */}
      <path
        d="M11 8h2v3h3v2h-3v3h-2v-3H8v-2h3V8z"
        fill="white"
      />
    </svg>
  );
}

export function ThyroidIcon() {
  // Thyroid butterfly shape - based on thyroid.png reference
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Main thyroid shape - butterfly with upward curving lobes */}
      <path
        d="M12 8
           C10 8 9 6 8 4
           C7 2.5 5 2 3.5 3.5
           C2 5 2.5 7.5 3.5 10
           C4.5 12.5 5 15 6 18
           C6.5 20 8 21 10 21
           C11 21 11.5 20 12 19
           C12.5 20 13 21 14 21
           C16 21 17.5 20 18 18
           C19 15 19.5 12.5 20.5 10
           C21.5 7.5 22 5 20.5 3.5
           C19 2 17 2.5 16 4
           C15 6 14 8 12 8Z"
        fill={colors.thyroid}
      />
      {/* White highlight on left lobe */}
      <path
        d="M5 5.5 C5.5 4 6.5 3.5 7 4.5 C7.5 5.5 6.5 7 5.5 7.5 C4.5 8 4.5 7 5 5.5Z"
        fill="white"
        opacity="0.4"
      />
      {/* White highlight on right lobe */}
      <path
        d="M19 5.5 C18.5 4 17.5 3.5 17 4.5 C16.5 5.5 17.5 7 18.5 7.5 C19.5 8 19.5 7 19 5.5Z"
        fill="white"
        opacity="0.4"
      />
    </svg>
  );
}

export function FlameIcon() {
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer flame with multiple points */}
      <path
        d="M12 1c0 0-2 3-3 5-.5 1-.5 2 .5 2 .5 0 1-.5 1.5-1.5.3-.5.5-1 1-1 0 0-3.5 5-3.5 10 0 5 2.5 7.5 5.5 7.5s5.5-2.5 5.5-7.5c0-5-3.5-10-3.5-10 .5 0 .7.5 1 1 .5 1 1 1.5 1.5 1.5 1 0 1-1 .5-2-1-2-3-5-3-5-.5 1-1.5 3-1.5 3s-1-2-1.5-3z"
        fill={colors.flame}
      />
      {/* Middle flame layer */}
      <path
        d="M12 7c0 0-1.5 2-2 3.5-.3.8 0 1.5.8 1.5.4 0 .7-.3 1.2-1 0 0-2 3.5-2 6 0 2.5 1 4 2 4s2-1.5 2-4c0-2.5-2-6-2-6 .5.7.8 1 1.2 1 .8 0 1.1-.7.8-1.5-.5-1.5-2-3.5-2-3.5z"
        fill={colors.flame}
        opacity="0.75"
      />
      {/* Inner core - bright yellow */}
      <path
        d="M12 13c0 0-1.2 2-1.2 3.5 0 .8.5 1.5 1.2 1.5s1.2-.7 1.2-1.5c0-1.5-1.2-3.5-1.2-3.5z"
        fill="#fcd34d"
        opacity="0.9"
      />
    </svg>
  );
}

export function StomachIcon() {
  // Stomach from organ-stomach2.svg - teal colored with filled lower portion
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.39,12.69 C16.72,11.33,15,15.57,22.1,13 A10.7,10.7,0,0,1,18.82,18.09 A10.74,10.74,0,0,1,11.89,20.64 H11.27 A4,4,0,0,1,7.84,18.75 A2.86,2.86,0,0,0,5.29,21.6 V23.5 H1.46 V21.57 A6.69,6.69,0,0,1,7.56,14.9 A3.71,3.71,0,0,1,8.4,13.69 Z" fill={colors.stomach} stroke="none"/>
      <g stroke={colors.stomach} strokeWidth="1.92" strokeMiterlimit="10" fill="none">
        <path d="M3.38.5v1a6.63,6.63,0,0,0,2,4.74,6.66,6.66,0,0,0,4.74,2h1v.95a4.63,4.63,0,0,1-1.35,3.27L8.4,13.69a3.71,3.71,0,0,0-.84,1.21h0a6.69,6.69,0,0,0-6.1,6.67V23.5"/>
        <path d="M7.21.5v1a2.87,2.87,0,0,0,2.87,2.87h1.74A5.75,5.75,0,0,1,22.54,7.21V10a10.7,10.7,0,0,1-3.72,8.09,10.74,10.74,0,0,1-6.93,2.55h-.62a4,4,0,0,1-3.43-1.89,2.86,2.86,0,0,0-2.55,2.85V23.5"/>
        <path d="M9.39,12.69C16.72,11.33,15,15.57,22.1,13"/>
      </g>
    </svg>
  );
}

export function BoneIcon() {
  // Bone from organ-bone2.svg - diagonal bone with round joints
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 5.5C18 5.6939 17.9779 5.88264 17.9362 6.06385C18.1174 6.02207 18.3061 6 18.5 6C19.8807 6 21 7.11929 21 8.5C21 9.88071 19.8807 11 18.5 11C17.7411 11 16.9411 10.836 16.2614 11.1734C15.4685 11.567 14.7401 12.0884 14.1073 12.7213L12.7214 14.1072C12.0885 14.7401 11.567 15.4685 11.1734 16.2615C10.836 16.9412 11 17.7412 11 18.5C11 19.8807 9.88071 21 8.5 21C7.11929 21 6 19.8807 6 18.5C6 18.3061 6.02207 18.1174 6.06385 17.9362C5.88264 17.9779 5.6939 18 5.5 18C4.11929 18 3 16.8807 3 15.5C3 14.1193 4.11929 13 5.5 13C6.25893 13 7.05907 13.1641 7.73885 12.8266C8.53173 12.433 9.2601 11.9116 9.89295 11.2787L11.2788 9.89284C11.9116 9.26007 12.433 8.53178 12.8266 7.739C13.1641 7.05919 13 6.25898 13 5.5C13 4.11929 14.1193 3 15.5 3C16.8807 3 18 4.11929 18 5.5Z"
        fill={colors.bone}
        stroke="none"
      />
    </svg>
  );
}

export function HormoneIcon() {
  // Stylized gland/hormone molecule icon - pink
  return (
    <svg style={iconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Central hexagon (steroid ring) */}
      <path
        d="M12 4L17.196 7V13L12 16L6.804 13V7L12 4Z"
        fill={colors.hormone}
      />
      {/* Upper bond */}
      <line x1="12" y1="4" x2="12" y2="1.5" stroke={colors.hormone} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12" cy="1" r="1" fill={colors.hormone}/>
      {/* Lower bond */}
      <line x1="12" y1="16" x2="12" y2="18.5" stroke={colors.hormone} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12" cy="19" r="1" fill={colors.hormone}/>
      {/* Left bond */}
      <line x1="6.804" y1="10" x2="4.5" y2="11.5" stroke={colors.hormone} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="4" cy="12" r="1" fill={colors.hormone}/>
      {/* Right bond */}
      <line x1="17.196" y1="10" x2="19.5" y2="11.5" stroke={colors.hormone} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="20" cy="12" r="1" fill={colors.hormone}/>
      {/* Inner highlight */}
      <path
        d="M12 6.5L14.598 8V11L12 12.5L9.402 11V8L12 6.5Z"
        fill="white"
        opacity="0.3"
      />
    </svg>
  );
}

// Icon map for easy access
const IconComponents = {
  glucose: GlucoseIcon,
  kidney: KidneyIcon,
  liver: LiverIcon,
  heart: HeartIcon,
  blood: BloodIcon,
  shield: ShieldIcon,
  thyroid: ThyroidIcon,
  flame: FlameIcon,
  stomach: StomachIcon,
  bone: BoneIcon,
  hormone: HormoneIcon
};

export function OrganIcon({ icon }) {
  const IconComponent = IconComponents[icon];
  if (!IconComponent) return null;
  return <IconComponent />;
}

export default OrganIcon;
